import * as yup from 'yup';

export const validationMessage = {
  firstName: {
    id: 'guestInfo.form.firstName.validation',
    defaultMessage: 'First name is required',
  },
  lastName: {
    id: 'guestInfo.form.lastName.validation',
    defaultMessage: 'Last name is required',
  },
  contributorFirstName: {
    id: 'guestInfo.form.contributorFirstName.validation',
    defaultMessage: 'Contributor first name is required',
  },
  contributorLastName: {
    id: 'guestInfo.form.contributorLastName.validation',
    defaultMessage: 'Contributor last name is required',
  },
  emailRequired: {
    id: 'guestInfo.form.emailId.required.validation',
    defaultMessage: 'Email is required',
  },
  emailInvalid: {
    id: 'guestInfo.form.emailId.invalid.validation',
    defaultMessage: 'Email is not proper',
  },
  address: {
    id: 'guestInfo.form.address.validation',
    defaultMessage: 'Address is required',
  },
  city: {
    id: 'guestInfo.form.city.validation',
    defaultMessage: 'City is required',
  },
  country: {
    id: 'guestInfo.form.country.validation',
    defaultMessage: 'Country is required',
  },
  postcode: {
    id: 'guestInfo.form.postcode.validation',
    defaultMessage: 'Postal code is required',
  },
  phoneNumber: {
    id: 'guestInfo.form.phoneNumber.validation',
    defaultMessage: 'Phone number is required',
  },
  phoneNumberMin: {
    id: 'guestInfo.form.phoneNumberMin.validation',
    defaultMessage: 'Phone number format is incorrect',
  },
};

export default yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required(() => validationMessage.firstName),
  lastName: yup
    .string()
    .trim()
    .required(() => validationMessage.lastName),
  isContributorAnotherPerson: yup.boolean(),
  contributorFirstName: yup.string().when('isContributorAnotherPerson', {
    is: true,
    then: () =>
      yup
        .string()
        .trim()
        .required(() => validationMessage.contributorFirstName),
  }),
  contributorLastName: yup.string().when('isContributorAnotherPerson', {
    is: true,
    then: () =>
      yup
        .string()
        .trim()
        .required(() => validationMessage.contributorLastName),
  }),
  email: yup
    .string()
    .trim()
    .email(() => validationMessage.emailInvalid)
    .required(() => validationMessage.emailRequired),
  address: yup
    .string()
    .trim()
    .required(() => validationMessage.address),
  city: yup
    .string()
    .trim()
    .required(() => validationMessage.city),
  country: yup
    .string()
    .trim()
    .required(() => validationMessage.country),
  postalCode: yup
    .string()
    .trim()
    .required(() => validationMessage.postcode),
  phoneNo: yup
    .string()
    .required(() => validationMessage.phoneNumber)
    .test({
      name: 'invalidFormat',
      message: () => validationMessage.phoneNumberMin,
      test(phoneNo) {
        const formatMask = this.parent.format || '';

        const regexMask = formatMask
          .replace(/\(/g, '\\(')
          .replace(/\)/g, '\\)')
          .replace(/\./g, '\\d')
          .replace(/\+/g, '\\+')
          .replace(/\s/g, '\\s')
          .replace(/\d+/g, '\\d+');

        const formatRegex = new RegExp(`^${regexMask}$`);

        return formatRegex.test(phoneNo);
      },
    }),
});
